/* ============================================================
   ラインプロパティ用スクリプト (main-product-custom.liquid 用)
   assets/line-properties-custom.js として配置してください
   ============================================================ */
document.addEventListener('DOMContentLoaded', function () {

  // メッセージカード希望チェックボックスでテキストエリアの表示/非表示を切替
  document.querySelectorAll('.line-property-toggle').forEach(function (checkbox) {
    var targetId = checkbox.getAttribute('data-toggle-target');
    var target = document.getElementById(targetId);
    if (!target) return;

    function sync() {
      if (checkbox.checked) {
        target.classList.add('is-visible');
      } else {
        target.classList.remove('is-visible');
      }
    }
    sync();
    checkbox.addEventListener('change', sync);
  });

  // 添付ファイル選択時にファイル名をボタンに表示
  document.querySelectorAll('.line-property-file-input').forEach(function (input) {
    var labelId = input.getAttribute('data-label-target');
    var label = document.getElementById(labelId);
    if (!label) return;

    input.addEventListener('change', function () {
      if (input.files && input.files[0]) {
        label.textContent = input.files[0].name;
      } else {
        label.textContent = '添付ファイル';
      }
    });
  });
});